<template>
  <v-chip :color="chipColor" :text-color="textColor">{{this.status}}</v-chip>
</template>

<script>
  import {
    VCard,
    VChip,
  } from 'vuetify/lib'

  export default {
    name: 'FCCApplicationStatus',
    data: () => ({
      
    }),
    methods: {
      
    },
    computed: {
      chipColor: function(){
        if(this.status == "Ready to start") return "green";
        if(this.status == "Canceled") return "red";
        if(this.status == "Confirmed") return "yellow";
        if(this.status == "Pending") return "orange";
        if(this.status == "Filed") return "default";
        return "default";
      },
      textColor: function(){
        if(this.status == "Ready to start") return "white";
        if(this.status == "Canceled") return "white";
        if(this.status == "Confirmed") return "black";
        if(this.status == "Pending") return "black";
        if(this.status == "Filed") return "black";
        return "white";
      }
    },
    props: {
      status: String
    },
    components: {
      VCard,
      VChip
    }
  }
</script>